export default __webpack_public_path__ + "721b0fcbffce2693d16d94eeeb5ff454.svg";